import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { STATUS } from '../enums/common'
import { handleError } from '../services/utils'
import { getCountriesList } from '../services/Kyc'
import { IOption } from '../interfaces/FormFields'

const useCountriesListHook = () => {
  const history = useHistory()
  const [fiscalCountriesList, setFiscalCountriesList] = useState<IOption[]>([])
  const [countriesStatus, setCountriesStatus] = useState<string>(STATUS.idle)

  useEffect(() => {
    async function getDropdownCountriesList() {
      setCountriesStatus(STATUS.pending)
      try {
        const countriesList = await getCountriesList()
        const processedCountries = Object.keys(countriesList)
          .map((key) => ({
            value: countriesList[key].value,
            label: countriesList[key].label,
          }))
          .sort((a, b) => a.label.localeCompare(b.label))

        setFiscalCountriesList([
          { value: '', label: 'Sélectionner' },
          ...processedCountries,
        ])

        setCountriesStatus(STATUS.loaded)
      } catch (e) {
        setCountriesStatus(STATUS.failed)
        handleError(e, history, true)
      }
    }

    if (countriesStatus !== STATUS.pending) {
      getDropdownCountriesList()
    }
  }, [])

  return {
    fiscalCountriesList,
    countriesStatus,
  }
}

export default useCountriesListHook
